<template>
	<section class="section section--bg">
	  <div class="container">
		<div class="row">
		  <div class="col-12">
            <form class="form form--primary" method="post" @submit.prevent="submitForm($event)" id="formWhistleblowing" autocomplete="off">

                <Modal v-model="showModal" :title="formTitle" :status="formSuccess" :message="formMessage" @close="resetModal" template="whistleblowing" />

                <TabPrimary v-model="activeTab" :tabs="charterTabs">
                <TabPane id="one">
                    <div class="section__block" v-html="translate('whistleblowing.tab.one')"></div>
                    <div class="row justify-content-center">
                        <div class="col-xl-8">
                            <div class="section__wrapper">
                                <div class="custom-control custom-checkbox">
                                    <input 
                                    v-model="privacyStatement"
                                    type="checkbox" 
                                    class="custom-control-input" 
                                    name="privacyStatement">
                                    <label class="custom-control-label" v-html="translate('whistleblowing.tab.one.checkbox')"></label>
                                </div>

                                <div class="section__btn">
                                    <button 
                                    id="step1" 
                                    type="button" 
                                    class="btn btn--secondary" 
                                    @click="handleStep1Submit"
                                    :disabled="!privacyStatement">
                                        <span class="btn__title">{{ translate("next") }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPane>
                <TabPane id="two">
                    <div class="row justify-content-center">
                        <div class="col-xl-8">
                               <div class="mb-5" v-html="translate('whistleblowing.information')"></div>
                                <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label" for="fristname">{{ translate("fristname") }}</label>
                                        <input class="form-control" type="text" name="fristname" id="fristname" maxlength="100" value="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label" for="surname">{{ translate("surname") }}</label>
                                        <input class="form-control" type="text" name="surname" id="surname" maxlength="100" value="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label" for="telephone">{{ translate("telephone") }}</label>
                                        <input type="tel" class="form-control" id="telephone" name="telephone" maxlength="20" value="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label" for="email">{{ translate("email") }}</label>
                                        <input class="form-control" type="email" id="email" name="email" maxlength="50" value="">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label" for="companyname">{{ translate("companyname") }}</label>
                                        <input class="form-control" type="text" id="companyname" name="companyname" maxlength="100" value="" >
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label" for="address">{{ translate("address") }}</label>
                                        <input class="form-control" type="text" id="address" name="address" maxlength="2000" value="">
                                    </div>
                                </div>              
                                <div class="form__block mt-3">
                                    <div class="custom-control custom-checkbox">
                                        <input 
                                            type="checkbox" 
                                            class="custom-control-input" 
                                            name="privacyStatement2"
                                            v-model="privacyStatement2"
                                            @change="handleCheckboxChange"
                                        >
                                            <label class="custom-control-label" v-html="translate('privacy.statement.text')"></label>
                                    </div>
                                    <div class="form__btn">
                                        <button 
                                            type="button" 
                                            class="btn btn--secondary me-2" 
                                            id="step2"
                                            @click="handleStep2Back"
                                            :disabled="!privacyStatement"
                                        >
                                            <span class="btn__title">{{ translate("back") }}</span>
                                        </button>
                                        <button 
                                            type="button" 
                                            class="btn btn--secondary" 
                                            id="step2"
                                            @click="handleStep2Submit"
                                            :disabled="!privacyStatement2"
                                        >
                                            <span class="btn__title">{{ translate("submit") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPane>
                <TabPane id="three">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-5" v-html="translate('whistleblowing.incident')"></div>
                            <div class="form-group">
                                <label class="form-label"> {{ translate("subject") }}*</label>
                                <input type="text" class="form-control" size="40" name="subject" id="subject" maxlength="1000" value="" required>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{ translate("company.place.report") }}*</label>
                                <input type="text" class="form-control" name="companyplace" size="40" id="companyplace" maxlength="1000" value="" required>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{ translate("person.position.organization") }}*</label>
                                <input type="text" class="form-control" name="personposition" size="40" id="personposition" maxlength="1000" value="" required>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="detail">{{ translate("detail") }}*</label>
                                <textarea class="form-control" id="detail" name="detail" cols="40" rows="5" maxlength="10000" required></textarea>
                            </div>
                            <div class="form-group form-group--file-upload">
                                <label class="form-text" for="attach file">{{ translate("attach.a.file") }}</label>
                                <div class="custom-file custom-file-upload">
                                    <input type="file" id="inputFile" class="custom-file-input" name="file" accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" maxlength="5120" :placeholder="translate('upload')" @change="handleFileChange">
                                    <label class="custom-file-label">{{ selectedFileName }}</label>
                                </div>
                            </div>
                            <div class="custom-file-detail">{{ translate("attach.file.maximum") }}</div>
                            <div class="form__btn">
                                <button 
                                    type="button" 
                                    class="btn btn--secondary me-2" 
                                    id="step2"
                                    @click="handleStep3Back"
                                    :disabled="!privacyStatement"
                                >
                                    <span class="btn__title">{{ translate("back") }}</span>
                                </button>
                                <button type="submit" 
                                class="btn btn--secondary" 
                                :disabled="!isStep3Valid"
                                >
                                    <span class="btn__title">{{ translate("send") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>       
                </TabPane> 
                </TabPrimary>
            </form>
		  </div>
		</div>
	  </div>
	</section>
</template>

<script setup>
const isChecked = ref(false);
import { useWhistleblowing } from "@/composables/useWhistleblowing";
import Modal from "@/components/helpers/Modal.vue";
import Loading from "@/components/helpers/Loading.vue";

import TabPrimary from "~/components/apps/tabs/TabPrimary.vue";
import TabPane from "~/components/apps/tabs/TabPane.vue";

// ใช้ Composable
const {
  isLoading,
  LoadingTitle,
  formSuccess,
  formTitle,
  formMessage,
  showModal,
  privacyStatement,
  privacyStatement2,
  handleStep1Submit,
  handleStep2Back,
  handleStep2Submit,
  handleStep3Back,
  isStep3Valid,
  activeTab,
  submitForm,
  resetModal,
  translate,
} = useWhistleblowing();

const selectedFileName = ref(translate("no.choose.files"));

const handleFileChange = (event) => {
    const textAlert = "The file may not be greater than 5MB";
    var fileName = event.target.files[0].name;
    var fileInput = event.target;
    const file = fileInput.files[0];
    const maxSizeInBytes = 5 * 1024 * 1024;

    if (file.size <= maxSizeInBytes) {
        selectedFileName.value = fileName;
    } else {
        alert(textAlert);
        fileInput.value = null;
        selectedFileName.value = textAlert;
    }
};

const charterTabs = ref([
    { 
        id: 'one',
        title: translate('terms.and.conditions'),
        disabled: true

    },
    { 
        id: 'two',
        title: translate('whistleblower.information'),
        disabled: true
    },
    { 
        id: 'three',
        title: translate('incident.details'),
        disabled: true
    }
]);
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/app";

    .section{
        .section__block{
            color: $white;
			padding: 2.25rem 1.65rem;
			border-radius: 24px;
			border: 1px solid rgba($white, 0.50);
			backdrop-filter: blur(4px);
            @include primary-gradient(rgba($white, 0.20) 0%, rgba($darkgreen-2, 0.20) 123.43%, 180deg);
        }

        .section__wrapper{
            margin-top: 2.45rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            @include media-breakpoint-down(sm) {
                flex-direction: column;
            }
        }

        .section__btn{
            @include media-breakpoint-up(md) {
                margin-left: 2rem;
            }
            @include media-breakpoint-down(sm) {
                margin-top: 1.50rem;
            }
        }
    }

    .form{
        .form__btn{
            text-align: center;
            margin-top: 1.50rem;
            
            @include media-breakpoint-up(md) {
                margin-left: 0;
            }
        }
    }
   

</style>